import { render, staticRenderFns } from "./CompanyOfficial.vue?vue&type=template&id=1184aee5&scoped=true"
import script from "./CompanyOfficial.vue?vue&type=script&lang=js"
export * from "./CompanyOfficial.vue?vue&type=script&lang=js"
import style0 from "./CompanyOfficial.vue?vue&type=style&index=0&id=1184aee5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1184aee5",
  null
  
)

export default component.exports